import { render } from "./results-header.global.vue?vue&type=template&id=753cf601"
import script from "./results-header.global.vue?vue&type=script&lang=js"
export * from "./results-header.global.vue?vue&type=script&lang=js"

import "./results-header.global.vue?vue&type=style&index=0&id=753cf601&lang=scss"

import exportComponent from "/builds/grxl/cinematech/jmpt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__